var exports = {
  "k": "xa15a2ab7--4489ce--container",
  "n": "xa15a2ab7--4489ce--tabs-container",
};

module.exports = exports;
